import { Menu, MenuItem } from "@material-ui/core";
import React, { useState } from "react";
import styled from "styled-components";
import { WorkspaceUserRole } from "common/interfaces";

import { Icon as MaterialSymbolIcon } from "js/Components/Icon";
import AppController from "js/core/AppController";
import WorkspaceController from "js/controllers/WorkspaceController";
import { ds } from "js/core/models/dataService";
import { generateTeamWorkspaceAvatar } from "js/core/utilities/avatarGenerator";
import { trackActivity } from "js/core/utilities/utilities";
import { logoutZendesk } from "js/core/utilities/zendesk";
import Avatar from "js/react/components/Avatar";
import { Gap15 } from "js/react/components/Gap";
import { t } from "js/i18n";

const WorkspaceNameContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

const WorkspaceNameText = styled.span`
    color: #FFF;
    font-size: 14px;
    font-weight: 600;
    line-height: 150%;
`;

const UserMenuTrigger = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
    cursor: pointer;
    padding: 8px;

    &:hover {
        background: rgba(255, 255, 255, 0.10);
        border-radius: 2px;
    }
`;

const StyledManageAccountIcon = styled(MaterialSymbolIcon)`
    &&& {
        margin-right: 0;
        color: #666;
        font-size: 24px;
    }
`;

export default function PresentationLibraryAvatarMenu() {
    const [anchorEl, setAnchorEl] = useState(null);
    const user = AppController.user;
    const workspace = user?.workspacesMetadata?.find(item => item.id === AppController.workspaceId);

    const renderAvatar = () => {
        if (!workspace) {
            return <Avatar url={AppController.userAvatarUrl} style={{ width: "24px", height: "24px" }} />;
        }

        if (workspace.userRole === WorkspaceUserRole.GUEST) {
            return <Avatar url={workspace.workspacePhotoURL || AppController.userAvatarUrl} style={{ width: "24px", height: "24px" }} />;
        }

        if (WorkspaceController.isMultiUserWorkspace || !AppController.userAvatarUrl) {
            const WorkspaceAvatarComponent = generateTeamWorkspaceAvatar(workspace.name, 24);
            return <WorkspaceAvatarComponent style={{ width: "24px", height: "24px" }} />;
        }

        return <Avatar url={AppController.userAvatarUrl} style={{ width: "24px", height: "24px" }} />;
    };

    const handleOpenMenu = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleManageAccount = () => {
        AppController.showAccountPane({ pane: "me" });
        handleCloseMenu();
    };

    const handleLogout = () => {
        trackActivity("Auth", "logout", null, null, { workspace_id: "all" }, { audit: true });
        logoutZendesk();
        ds.shutdown();
        window.location = "/logout";
    };

    return (
        <>
            <UserMenuTrigger id="presentation-library-user-menu-trigger" onClick={handleOpenMenu}>
                {renderAvatar()}
            </UserMenuTrigger>
            <Menu
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                autoFocus={false}
                disableAutoFocusItem
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                onClose={handleCloseMenu}
            >
                <MenuItem onClick={handleManageAccount}>
                    <StyledManageAccountIcon outlined>manage_accounts</StyledManageAccountIcon>
                    <Gap15 />
                    <span>{t("Manage Account")}</span>
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                    <StyledManageAccountIcon outlined>logout</StyledManageAccountIcon>
                    <Gap15 />
                    <span>{t("Log out")}</span>
                </MenuItem>
            </Menu>
        </>
    );
}
